import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Title from '../../components/Telephone/Title';
import StyledButton from '@ertelecom/ui-react/components/buttons/styledButton';

const CalculationSection = styled.section`
  width: 100%;
  padding: 118px 87px;
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;

  @media only screen and (max-width: 1365px) {
    padding: 90px 134px 99px;
  }

  @media only screen and (max-width: 1023px) {
    padding: 90px 45px 100px;
  }

  @media only screen and (max-width: 767px) {
    padding: 72px 19px 85px;
  }
`;

const Button = styled(StyledButton)`
  width: 227px;
  margin: 0 auto;
  margin-top: 54px;

  @media only screen and (max-width: 1365px) {
    margin-top: 50px;
  }

  @media only screen and (max-width: 1023px) {
    margin-top: 55px;
  }

  @media only screen and (max-width: 767px) {
    width: 248px;
    margin-top: 38px;
  }
`;

export default class Calculation extends Component {
  static propTypes = {
    title: PropTypes.string,
    text: PropTypes.string,
  };

  render() {
    const { title, text, className } = this.props;

    return (
      <CalculationSection className={className} >
        <Title as='h3' title={title} text={text} />
        <Button type='primary' href='/telephone/calc' target='_blank'>Перейти в калькулятор</Button>
      </CalculationSection>
    );
  }
}
